module.exports = __webpack_public_path__ + "static/media/SK01@s.51352a11.jpg";